import { cx } from '@linaria/core';
import { RoundedCheckmarkIcon } from '@ui/kit/icons';
import { checkmark, wrapper } from './atom.checkmark.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Checkmark(props) {
  return /*#__PURE__*/jsxs("div", {
    className: cx(wrapper, props.className, props.emphasised && "emphasised"),
    children: [/*#__PURE__*/jsx("div", {
      className: checkmark,
      children: /*#__PURE__*/jsx(RoundedCheckmarkIcon, {})
    }), /*#__PURE__*/jsx("span", {
      children: "Delt med l\xE6rer"
    })]
  });
}

export { Checkmark };
//# sourceMappingURL=atom.checkmark.js.map
